interface Agreement {
  terms: boolean;
  privacy: boolean;
  marketing: boolean;
}

interface BusinessAgreementsProps {
  agreementData: Agreement;
  onAgreementChange: (field: keyof Agreement, checked: boolean) => void;
  onAllAgreementChange: (checked: boolean) => void;
  className?: string;
}

export function BusinessAgreements({ 
  agreementData, 
  onAgreementChange, 
  onAllAgreementChange,
  className = '' 
}: BusinessAgreementsProps) {
  
  const handleTermsView = (title: string) => {
    const encodedTitle = encodeURIComponent(title);
    window.open(`/mypage/terms-policies/title/${encodedTitle}`, '_blank');
  };

  const isAllChecked = agreementData.terms && agreementData.privacy && agreementData.marketing;

  return (
    <div className={`space-y-6 ${className}`}>
      <h3 className="text-[20px] font-semibold text-[#222222]">약관 동의</h3>
      
      {/* 전체 동의 */}
      <div className="flex items-center p-4 bg-[#F5F5F5] rounded-lg border">
        <input
          type="checkbox"
          id="all-agreements"
          checked={isAllChecked}
          onChange={(e) => onAllAgreementChange(e.target.checked)}
          className="mr-4 w-5 h-5 text-[#51C854] rounded focus:ring-[#51C854] focus:ring-2"
        />
        <label htmlFor="all-agreements" className="text-[18px] font-semibold text-[#222222]">
          전체 동의
        </label>
      </div>

      {/* 개별 약관 */}
      <div className="space-y-4 pl-2">
        {/* 서비스 이용약관 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="terms"
              checked={agreementData.terms}
              onChange={(e) => onAgreementChange('terms', e.target.checked)}
              className="mr-4 w-4 h-4 text-[#51C854] rounded focus:ring-[#51C854] focus:ring-2"
            />
            <label htmlFor="terms" className="text-[16px] text-[#222222]">
              <span className="text-[#51C854] font-medium">[필수]</span> 서비스 이용약관
            </label>
          </div>
          <button
            type="button"
            onClick={() => handleTermsView('서비스이용약관(일반 및 공급기업용)')}
            className="text-[14px] text-[#666666] underline hover:text-[#51C854] transition-colors px-2 py-1"
          >
            더보기
          </button>
        </div>

        {/* 개인정보 처리방침 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="privacy"
              checked={agreementData.privacy}
              onChange={(e) => onAgreementChange('privacy', e.target.checked)}
              className="mr-4 w-4 h-4 text-[#51C854] rounded focus:ring-[#51C854] focus:ring-2"
            />
            <label htmlFor="privacy" className="text-[16px] text-[#222222]">
              <span className="text-[#51C854] font-medium">[필수]</span> 개인정보 처리방침
            </label>
          </div>
          <button
            type="button"
            onClick={() => handleTermsView('개인정보처리방침')}
            className="text-[14px] text-[#666666] underline hover:text-[#51C854] transition-colors px-2 py-1"
          >
            더보기
          </button>
        </div>

        {/* 마케팅 정보 수신 */}
        <div className="flex items-center">
          <input
            type="checkbox"
            id="marketing"
            checked={agreementData.marketing}
            onChange={(e) => onAgreementChange('marketing', e.target.checked)}
            className="mr-4 w-4 h-4 text-[#51C854] rounded focus:ring-[#51C854] focus:ring-2"
          />
          <label htmlFor="marketing" className="text-[16px] text-[#222222]">
            <span className="text-[#999999] font-medium">[선택]</span> 마케팅 정보 수신
          </label>
        </div>
      </div>

      {/* 필수 약관 안내 */}
      <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
        <p className="text-[14px] text-blue-600">
          <strong>필수 약관</strong>에 동의하셔야 회원가입을 진행할 수 있습니다.
        </p>
      </div>
    </div>
  );
}